jQuery(document).ready(function($) {
	function getUrlParam() {
		var url_string = window.location;
		var url = new URL(url_string);
		var c = url.searchParams.get("lang");
		return c;
 }
 if (getUrlParam() == "en") {
		MVAWizzard.setLocale("en");
 } else if (window.location == "https://www.my-vpa.com/") {
		MVAWizzard.setLocale("de__DU");
 }
 MVAWizzard.loadMain('#footer-wizzard');
 MVAWizzard.loadMainAndCenter('.embeddedWizzard');
 MVAWizzard.loadLoginForm();
 MVAWizzard.loadRegisterForm();
});